import { useRef, useState } from "react";

import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { Form } from "./Form";
import { EmptyBlackListStatus, IBlackListStatusMast, Table } from "./Table";

export interface IModal {
    singleData: IBlackListStatusMast,
    open: boolean
}

export const BlackListMast = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyBlackListStatus, open: false });
    };

    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>}
            {permissions.is_View && <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>}
            <Toast ref={toast} />
        </>
    );
}